import { Skeleton } from "@/components/ui/skeleton";

const DEFAULT_SKELETON_ROWS = 5;

interface EntitySelectorSkeletonProps {
  /** How many placeholder rows to render. */
  rows?: number;
}

/**
 * Renders placeholder rows matching the selector row height while results load.
 * @param props - How many placeholder rows to render
 * @returns The skeleton row list
 */
export function EntitySelectorSkeleton({
  rows = DEFAULT_SKELETON_ROWS,
}: EntitySelectorSkeletonProps) {
  return (
    <div className="p-1" aria-busy="true" aria-live="polite">
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className="flex items-center gap-2 rounded-sm px-2 py-1.5"
        >
          <Skeleton className="h-4 w-4 shrink-0 rounded-sm" />
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <Skeleton className="h-3.5 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
        </div>
      ))}
    </div>
  );
}
